import { useEffect, useState } from "react";
import axios from "axios";

function DeanClasses() {

  const token =
    localStorage.getItem("access");

  const [classes, setClasses] =
    useState([]);

  const [loading, setLoading] =
    useState(true);

  useEffect(() => {

    fetchClasses();

  }, []);

  const fetchClasses = async () => {

    try {

      const res = await axios.get(
        "https://api.eduskot.com/api/academics/dean/classes/",
        {
          headers:{
            Authorization:
            `Bearer ${token}`
          }
        }
      );

      setClasses(res.data);

    } catch(err){

      console.error(err);

    } finally {

      setLoading(false);
    }
  };

  return (

    <div style={styles.page}>

      <div style={styles.header}>

        <h1>
          🎓 My Dean Classes
        </h1>

        <button
          style={styles.backBtn}
          onClick={() =>
            window.location.href =
            "/teacher-dashboard"
          }
        >
          Back
        </button>

      </div>

      {loading ? (

        <h3>
          Loading...
        </h3>

      ) : (

        <div style={styles.grid}>

          {classes.map((item)=>(

            <div
  key={item.id}
  style={styles.card}
  onClick={() =>
    window.location.href =
    `/dean/students/${item.id}`
  }
>

              <h2>
                {item.name}
              </h2>

            </div>

          ))}

        </div>

      )}

    </div>
  );
}

const styles = {

  page:{
    padding:"30px",
    background:"#f8fafc",
    minHeight:"100vh"
  },

  header:{
    display:"flex",
    justifyContent:"space-between",
    alignItems:"center",
    marginBottom:"25px"
  },

  backBtn:{
    padding:"10px 16px",
    border:"none",
    borderRadius:"10px",
    background:"#2563eb",
    color:"white",
    cursor:"pointer"
  },

  grid:{
    display:"grid",
    gridTemplateColumns:
    "repeat(auto-fit,minmax(250px,1fr))",
    gap:"20px"
  },

  card:{
    background:"white",
    padding:"25px",
    borderRadius:"15px",
    textAlign:"center",
    boxShadow:
    "0 8px 20px rgba(0,0,0,0.08)"
  }
};

export default DeanClasses;